<template>
  <div
    class="detail_main">
    <div @click="$parent.show = false" class="detail_container"
    :class="{'bg_detail': bg}">
    </div>
      <section
        class="size_detail
          zero_right
          margin_top_detail
          padding_bottom_detail
          has-background-white
          is-scrollable">
        <div class="columns is-marginless detail_content_bg">
          <img :src="url" class="maxheight half_width" alt="">
          <div class="half_width leftVert topVert rightVert">
            <a @click="$parent.show = false"
              class="detail_icon_close_right">
              <b-icon
                icon="window-close"
                size="">
              </b-icon>
            </a>
            <h3 class="has-text-link has-text-weight-bold bottomVert">
              Proposition:</h3>
            <div class="columns is-multiline is-marginless color-icon">
              <div
                v-if="detailFaceNumerique.extensionOpportunite.quantite &&
                detailFaceNumerique.extensionOpportunite.typeTarification"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="timer"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Durée
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{formatDureeNum(detailFaceNumerique.extensionOpportunite.typeTarification,
                        detailFaceNumerique.extensionOpportunite.quantite)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFaceNumerique.extensionOpportunite.tarifHt"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="cash"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Tarif HT
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{tarifHt}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column bottomViolet is-paddingless is-6"
                v-if="detailFaceNumerique.extensionOpportunite.quantite &&
                  detailFaceNumerique.extensionOpportunite.typeTarification">
                <div class="media">
                  <b-icon
                    icon="cellphone-screenshot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Mode de diffusion
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{modeDiff(detailFaceNumerique.extensionOpportunite.typeTarification)}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFaceNumerique.extensionOpportunite.fraisAdserving"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="tooltip-plus"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Frais Adserving
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{fraisAdserving}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFaceNumerique.extensionOpportunite.taxeMunicipale"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="ballot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Taxes Municipales
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{taxeMunicipale}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFaceNumerique.extensionOpportunite.spotsPub"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="camera-metering-spot"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Spot(s) Publicitaire(s)
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailFaceNumerique.extensionOpportunite.spotsPub}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="detailFaceNumerique.extensionOpportunite.nbDiffusion"
                class="column bottomViolet is-paddingless is-6">
                <div class="media">
                  <b-icon
                    icon="counter"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Diffusion/jour
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailFaceNumerique.extensionOpportunite.nbDiffusion}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailFaceNumerique.extensionOpportunite.commentaire">
              <h3 class="has-text-link has-text-weight-bold topViolet">
                Commentaire:</h3>
              <div>
                <p class="has-text-link has-text-justify p_size14 mb-btnaction">
                  {{detailFaceNumerique.extensionOpportunite.commentaire}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="columns margin_medium">
          <div class="column is-paddingless">
            <h3 class="has-text-link has-text-weight-bold bottomViolet">
              Caractéristiques:
            </h3>
            <div class="columns is-marginless is-multiline color-icon">
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="map-marker"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Adresse
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{adresse}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailFaceNumerique.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless bottomViolet">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Matériel
                    </label><br>
                    <p class="p_size14 has-text-weight-bold has-text-link">
                      {{detailFaceNumerique.materiel}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="detailFaceNumerique.extensionOpportunite.periode"
                 class="column is-paddingless bottomViolet color-icon">
              <div class="media">
                <b-icon
                  icon="timer"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">
                    Période
                  </label><br>
                  <p class="p_size14 has-text-weight-bold has-text-link">
                    {{detailFaceNumerique.extensionOpportunite.periode}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column topRouge bottomVert is-4 is-offset-8">
              <div v-if="!detailFaceNumerique.select"
                @click="contolSelect()">
                <a class="button is-primary is-rounded p_size14 topVert rightVert">
                  Ajouter à ma sélection
                </a>
              </div>
              <div v-else
                @click="contolSelect()">
                <a class="button boutonRed has-text-white is-rounded p_size14 topVert rightVert">
                  Retirer de ma sélection
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import { formatNum, formatAdresse, urlPhoto, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';


export default {
  name: 'detailOpportunites',
  props: ['detailFaceNumerique', 'bg'],
  data() {
    return {
      select: true,
    };
  },
  computed: {
    tarifHt() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.tarifHt
      * this.detailFaceNumerique.extensionOpportunite.quantite);
    },
    fraisAdserving() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.fraisAdserving);
    },
    taxeMunicipale() {
      return formatNum(this.detailFaceNumerique.extensionOpportunite.taxeMunicipale);
    },
    adresse() {
      return formatAdresse(this.detailFaceNumerique);
    },
    url() {
      return urlPhoto(this.detailFaceNumerique.urlPhoto);
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.detailFaceNumerique.select = !this.detailFaceNumerique.select;
      if (this.detailFaceNumerique.select) {
        this.detailFaceNumerique.icon = iconColorGetter('#49db70', TAILLE_ICON_GRAND);
        this.add(this.detailFaceNumerique.extensionOpportunite.tarifHt
        * this.detailFaceNumerique.extensionOpportunite.quantite);
        this.addNbSelect();
      } else {
        this.detailFaceNumerique.icon = iconColorGetter('#009ce0', TAILLE_ICON_GRAND);
        this.substract(this.detailFaceNumerique.extensionOpportunite.tarifHt
        * this.detailFaceNumerique.extensionOpportunite.quantite);
        this.substractNbSelect();
      }
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/panneauxNumeriques/detailOpportunites.vue